import { Feature, NotaryCapacityType, NotaryActivationStatus } from "graphql_globals";

type NotaryProfileWithCapacity = {
  capacities: { type: NotaryCapacityType; status: NotaryActivationStatus }[];
};
type MeetingReadyNotaryProfile = {
  capacities: {
    type: NotaryCapacityType;
    status: NotaryActivationStatus;
    validation: { canAcceptMeetings: boolean };
  }[];
};

export function isNotaryProfileNotTerminatedFor(
  notaryProfile: NotaryProfileWithCapacity | null,
  desiredType: NotaryCapacityType,
): boolean {
  return Boolean(
    notaryProfile?.capacities.some(
      (capacity) =>
        capacity.status !== NotaryActivationStatus.TERMINATED && capacity.type === desiredType,
    ),
  );
}

export function isNotaryNST(notaryProfile: NotaryProfileWithCapacity | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some(
      (cap) => cap.type === NotaryCapacityType.BRING_YOUR_OWN_TRANSACTIONS,
    ),
  );
}

export function isNotaryODN(notaryProfile: NotaryProfileWithCapacity | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some((cap) => cap.type === NotaryCapacityType.ON_DEMAND),
  );
}

export function isNotaryIHN(notaryProfile: NotaryProfileWithCapacity | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some((cap) => cap.type === NotaryCapacityType.ORGANIZATION_NOTARY),
  );
}

export function isIndependentNotary(notaryProfile: NotaryProfileWithCapacity | null) {
  return Boolean(isNotaryNST(notaryProfile) || isNotaryODN(notaryProfile));
}

export function isNotaryODNCallReady(notaryProfile: MeetingReadyNotaryProfile | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some(
      (cap) =>
        cap.type === NotaryCapacityType.ON_DEMAND &&
        cap.status === NotaryActivationStatus.ACCEPTED &&
        cap.validation.canAcceptMeetings,
    ),
  );
}

export function isNotaryIHNCallReady(notaryProfile: MeetingReadyNotaryProfile | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some(
      (cap) =>
        cap.type === NotaryCapacityType.ORGANIZATION_NOTARY &&
        cap.status === NotaryActivationStatus.ACCEPTED &&
        cap.validation.canAcceptMeetings,
    ),
  );
}

export function isNotaryNSTCallReady(notaryProfile: MeetingReadyNotaryProfile | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some(
      (cap) =>
        cap.type === NotaryCapacityType.BRING_YOUR_OWN_TRANSACTIONS &&
        cap.status === NotaryActivationStatus.ACCEPTED &&
        cap.validation.canAcceptMeetings,
    ),
  );
}

export function isNotaryCallReady(notaryProfile: MeetingReadyNotaryProfile | null): boolean {
  return Boolean(
    notaryProfile?.capacities.some(
      (cap) => cap.status === NotaryActivationStatus.ACCEPTED && cap.validation.canAcceptMeetings,
    ),
  );
}

export function isBusinessPortalReady(
  notaryProfile: NotaryProfileWithCapacity | null,
  organization: { featureList: Feature[] } | null,
): boolean {
  return Boolean(
    // all users must have this org feature flag
    organization?.featureList.includes(Feature.BUSINESS_PORTAL_ACCESS) &&
      (!notaryProfile || // Those who are not a notary are allowed
        // allow anyone whos IHN or NST
        isNotaryNST(notaryProfile) ||
        isNotaryIHN(notaryProfile)),
  );
}
